import { listItemWrapper, pagedListWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Category, Post } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { getItem: getCategory } = listItemWrapper<Category>(apiClient, {
      path: `/api/v${version}/blog/categories`
    })

    const { getItem: getPost } = listItemWrapper<Post>(apiClient, {
      path: `/api/v${version}/blog/posts`
    })

    const posts = pagedListWrapper<'id', Post>()(apiClient, {
      path: `/api/v${version}/blog/posts`,
      idKey: 'id',
      requestOptions: {
        cache: {
          ttl: 60000 // 1m
        }
      }
    })

    return { getCategory, posts, getPost }
  }
} satisfies Starter
